import { render } from "./InsTaskLongFormModal.vue?vue&type=template&id=11077d51&scoped=true"
import script from "./InsTaskLongFormModal.vue?vue&type=script&lang=js"
export * from "./InsTaskLongFormModal.vue?vue&type=script&lang=js"

import "./InsTaskLongFormModal.vue?vue&type=style&index=0&id=11077d51&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11077d51"]])

export default __exports__